// extracted by mini-css-extract-plugin
export default {"count":"tag_count__g0dUwl4x"};